(function () {
  function initCarousel(wrapper) {
    var track = wrapper.querySelector('[data-video-carousel-track]');
    var prev = wrapper.querySelector('[data-video-carousel-prev]');
    var next = wrapper.querySelector('[data-video-carousel-next]');
    var dots = Array.prototype.slice.call(
      wrapper.querySelectorAll('[data-video-carousel-dot]')
    );
    if (!track) return;

    function slideWidth() {
      var first = track.querySelector('.video-carousel__slide');
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      var w = slideWidth();
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }

    function maxIndex() {
      var slides = track.querySelectorAll('.video-carousel__slide').length;
      return Math.max(0, slides - 1);
    }

    function scrollToIndex(i) {
      var w = slideWidth();
      if (!w) return;
      var clamped = Math.max(0, Math.min(i, maxIndex()));
      track.scrollTo({ left: clamped * w, behavior: 'smooth' });
    }

    function updateControls() {
      var i = currentIndex();
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === i);
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToIndex(currentIndex() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollToIndex(currentIndex() + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-video-carousel-dot'), 10) || 0;
        scrollToIndex(idx);
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateControls, 60);
    });
    window.addEventListener('resize', updateControls);

    updateControls();

    var videos = wrapper.querySelectorAll('video');
    videos.forEach(function (v) {
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('[data-video-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-video-carousel]');
    if (el) initCarousel(el);
  });
})();
